import { render, staticRenderFns } from "./GalleryWriteModalLayout.vue?vue&type=template&id=2c2d25fe&scoped=true"
import script from "./GalleryWriteModalLayout.vue?vue&type=script&lang=js"
export * from "./GalleryWriteModalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d25fe",
  null
  
)

export default component.exports